import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { buildDashboardPath, buildLocaleRootPath, getPreferredLang } from '../lib/routes';
import { dispatchGuildSelection } from '../lib/guildSelection';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshSession } = useAuth();
  const callbackError = searchParams.get('error');

  useEffect(() => {
    let cancelled = false;
    window.history.replaceState(null, document.title, window.location.pathname);

    const confirmSession = async () => {
      if (callbackError) {
        navigate(buildLocaleRootPath(getPreferredLang()), { replace: true });
        return;
      }

      const currentUser = await refreshSession();
      if (cancelled) return;

      if (!currentUser) {
        navigate(buildLocaleRootPath(getPreferredLang()), { replace: true });
        return;
      }

      localStorage.removeItem('tns:selected_guild_id');
      localStorage.removeItem('tns:selected_guild_access');
      localStorage.removeItem('tns:selected_guild_scopes');
      dispatchGuildSelection(null);
      navigate(buildDashboardPath(getPreferredLang(), 'profile'), { replace: true });
    };

    confirmSession();
    return () => {
      cancelled = true;
    };
  }, [callbackError, navigate, refreshSession]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
};
